import * as Yup from 'yup'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Cart} from '../../../cart/list/core/_models'
import {Location} from '../../../location/list/core/_models'
import {Service} from '../../../service/list/core/_models'
import {User} from '../../../staff/list/core/_models'
export type Booking = {
  id?: ID
  completed?: boolean
  description?: string
  staff_id?: string
  date?: string
  start_time?: string
  end_time?: string
  start_time1?: string
  end_time1?: string
  staff_review?: string
  customer_review?: string
  staff_rating?: number
  business_id?: number
  cart_id?: number
  service_location_id?: number
  customer_invoice_id?: number
  staff_invoice_id?: number
  location_id?: string
  service_id?: ID
  service?: Service
  location?: Location
  cart?: Cart
  staff?: User
  decline?: boolean
  created_by?: ID
  timesheets?: Timesheet[]
  timezone?: string
  status?: boolean
  staff_custom_charge?: number
  service_charge?: number
  customer?: Customer
  url?: URL
  quantity?: number
  reviews?: Review[]
}
type Customer = {
  first_name?: string
  last_name?: string
  email?: string
  phone?: string
  country?: string
  state?: string
}

export type Timesheet = {
  id?: ID
  staff_id?: string
  date?: string
  start_time?: Date
  end_time?: Date
  clock_in?: Date
  clock_out?: Date
  staff?: User
  booking_id?: ID
  status?: boolean
}
export type Summary = {
  total_bookings: number
  completed_bookings: number
  paid_revenue: number
  total_revenue: number
  total_ms: number
  total_ms_completed: number
}
export type Review = {
  type?: 'customer' | 'staff'
  review: string
  rating?: number
  booking_id: ID
  created_by?: string
}

export type BookingsQueryResponse = Response<Array<Booking>>

export const initialBooking: Booking = {
  // location_id: '',
  // service_id: '',
  date: '',
  start_time: '',
  end_time: '',
  start_time1: '',
  end_time1: '',
}

export const createBookingSchemas = [
  Yup.object().shape({
    location_id: Yup.number().required().label('Location'),
  }),
  Yup.object().shape({
    service_id: Yup.number().required().label('Service'),
  }),
  Yup.object().shape({
    staff_id: Yup.string().label('User'),
  }),
  Yup.object().shape({
    date: Yup.date().required().label('Date'),
    start_time: Yup.date().required().label('Start Time'),
  }),
]
